(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const animate = (scope = document) => {
    if (reduced || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('animate-in'); observer.unobserve(entry.target); }
    }), {threshold:.1});
    scope.querySelectorAll('.section-head,.editorial,.product-card,.newsletter').forEach(el => observer.observe(el));
  };
  animate();
  document.addEventListener('shopify:section:load', event => animate(event.target));
  document.addEventListener('click', event => {
    if (event.target.closest('[data-close]')) event.target.closest('dialog')?.close();
  });
  const notice = document.getElementById('CartNotice');
  notice?.addEventListener('click', event => { if (event.target === notice) { const r=notice.getBoundingClientRect(); if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)notice.close(); } });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-variant-select]')) return;
    const url = new URL(location.href);
    url.searchParams.set('variant', event.target.value);
    // Shopify renders the selected variant price, stock and quantity rules on reload.
    location.assign(url.href);
  });
  document.addEventListener('keydown', event => {
    if (event.key==='Escape') document.querySelectorAll('.mobile-menu[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});
  });
})();
